/*
 * Die Symbole der Schulung.
 *
 * **Sie stehen auf jeder Folie an derselben Stelle** — rechts oben, immer in
 * derselben Reihenfolge (Verwaltung · Lehrkraft · Schüler:in · Unterstützer:in).
 * Das ist der ganze Trick: Wer zwanzig Folien durchblättert, soll die Frage
 * „betrifft das die Schulen?" mit einem Blick beantworten und nicht jedes Mal
 * einen Satz lesen müssen. Ein nicht betroffenes Symbol verschwindet nicht,
 * sondern wird blass — sonst verschöbe sich die Reihe und die feste Stelle wäre
 * dahin.
 *
 * Bewusst eigene SVGs statt der Icon-Sammlung der Anwendung: Die vier müssen
 * **nebeneinander** funktionieren, in einer Größe, mit derselben Strichstärke
 * und demselben optischen Gewicht. Zusammengesuchte Symbole tun das nie.
 *
 * `flex: 0 0 <px>` an jedem svg ist Pflicht, nicht Geschmack: In dieser
 * Anwendung gilt global `svg { flex: 1 1 0% }`, und ohne Gegenwehr zieht sich
 * ein Symbol in einer Flex-Reihe auf null zusammen.
 */

const gemeinsam = {
	viewBox: '0 0 24 24',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 1.7,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
	'aria-hidden': 'true'
}

/** Verwaltung: ein Gebäude mit Fahne — die Amtsstube, nicht die Schule. */
export const IconIntern = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M4 20h16" />
		<path d="M6 20V9l6-4 6 4v11" />
		<path d="M10 20v-5h4v5" />
		<path d="M12 5V2.8" />
	</svg>
)

/** Lehrkraft: eine Tafel mit Zeigestock. */
export const IconTeacher = props => (
	<svg {...gemeinsam} {...props}>
		<rect x="3" y="4" width="14" height="11" rx="1.6" />
		<path d="M6.5 8.5h7M6.5 11.5h4" />
		<path d="M10 15v5" />
		<path d="M17.5 6.5 21 3" />
	</svg>
)

/** Schüler:in: Kopf mit Absolventenhut, klar von der Lehrkraft unterschieden. */
export const IconStudent = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M12 3 3 7.2l9 4.2 9-4.2L12 3Z" />
		<path d="M6.6 9.4v4.2c0 1.9 2.4 3.4 5.4 3.4s5.4-1.5 5.4-3.4V9.4" />
		<path d="M21 7.2v5" />
	</svg>
)

/** Unterstützer:in: zwei Hände, die etwas halten. */
export const IconSupporter = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M3 12.5 6.5 9l3 2.5" />
		<path d="M21 12.5 17.5 9l-3 2.5" />
		<path d="M6.5 9v7.5c0 1.4 1.2 2.5 2.6 2.5h5.8c1.4 0 2.6-1.1 2.6-2.5V9" />
		<path d="M12 4.2v4.6M9.8 6.4 12 4.2l2.2 2.2" />
	</svg>
)

export const AUDIENCE_ICONS = {
	INTERN: IconIntern,
	TEACHER: IconTeacher,
	STUDENT: IconStudent,
	SUPPORTER: IconSupporter
}

/** Joker „50:50" — die Schere, die zwei Antworten wegnimmt. */
export const IconHalf = props => (
	<svg {...gemeinsam} {...props}>
		<circle cx="6" cy="6.5" r="2.4" />
		<circle cx="6" cy="17.5" r="2.4" />
		<path d="M8 8 20 18M8 16 20 6" />
	</svg>
)

/** Joker „Tipp" — die Glühbirne. */
export const IconHint = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M9 18h6" />
		<path d="M10 21h4" />
		<path d="M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6V16h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" />
	</svg>
)

/** Joker „Nachschlagen" — das aufgeschlagene Buch. */
export const IconBook = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M12 6.5S10 4.5 4 4.5v13c6 0 8 2 8 2s2-2 8-2v-13c-6 0-8 2-8 2Z" />
		<path d="M12 6.5v13" />
	</svg>
)

/** Haken für richtige Antworten und erledigte Aufgaben. */
export const IconCheck = props => (
	<svg {...gemeinsam} {...props}>
		<path d="m4.5 12.5 5 5 10-11" />
	</svg>
)

/** Kreuz für falsche Antworten. */
export const IconCross = props => (
	<svg {...gemeinsam} {...props}>
		<path d="M6 6 18 18M18 6 6 18" />
	</svg>
)

/** Das Siegel auf der Abschlusskarte. */
export const IconSeal = props => (
	<svg {...gemeinsam} {...props}>
		<circle cx="12" cy="9.5" r="5.5" />
		<path d="m4.5 12.5 5 5 10-11" opacity="0" />
		<path d="M9.6 9.6l1.7 1.7 3.3-3.5" />
		<path d="M8.6 14.6 7 22l5-2.4L17 22l-1.6-7.4" />
	</svg>
)
